import React from 'react';

import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from '@nhl/nhl-breakaway-ui';

import seasonSelectors from '~/redux/ducks/config/selectors';
import { reportActionCreators } from '~/redux/ducks/playersAndTeams/report';
import { commonMessages } from '~/utility/commonMessages';
import { GAME_TYPE_IDS } from '~/utility/constants';

import Label from '../../label';
import { SelectContainer } from '../styles';

const GameTypeSelect = () => {
    const dispatch = useDispatch();
    const intl = useIntl();

    const setGameType = (e, { value }) => {
        dispatch(reportActionCreators.setGameType(value));
        dispatch(reportActionCreators.runReport());
    };

    const currentReport = useSelector((state) => state.playersAndTeams.report.current);
    const currentSeasonInfo = useSelector((state) => state.config.fieldDefaultData);
    const statsConfig = useSelector((state) => state.config);

    const includePlayoffs = seasonSelectors.isPlayoffsInSelectedRange(statsConfig, currentReport);
    const tempOptions = GAME_TYPE_IDS.map((id) => ({
        value: id,
        label: intl.formatMessage(commonMessages.gameType[id]),
        key: id,
    }));
    const options = !includePlayoffs
        ? tempOptions.filter((obj) => obj.value <= currentSeasonInfo.gameTypeId)
        : tempOptions;

    const selectValue = options.find((opt) => opt.value === currentReport.gameTypeId);
    return (
        <SelectContainer>
            <Label htmlFor="gameType">{intl.formatMessage(commonMessages.labels.gameType)}</Label>
            <Select
                options={options}
                onOptionChange={setGameType}
                name="gameType"
                selectedOption={selectValue}
                isSearchEnabled
                optionsBoxAriaLabel={intl.formatMessage(commonMessages.labels.gameType)}
                dropdownButtonAriaLabel=""
            />
        </SelectContainer>
    );
};

export default React.memo(GameTypeSelect);
